module.exports = __webpack_public_path__ + "img/klb.77a39417.jpg";